<template>
  <header class="nav" aria-label="Campaign navigation">
    <div class="nav__inner">
      <div class="nav__ghost" aria-hidden="true"></div>

      <nav class="nav__links" aria-label="Primary">
        <NuxtLink :to="paths.brand" class="nav__link">Brand</NuxtLink>
        <NuxtLink :to="paths.ankleBoots" class="nav__link">Ankle boots</NuxtLink>
        <PreorderCartTrigger class-name="nav__action">Allocation</PreorderCartTrigger>
      </nav>

      <div class="nav__actions">
        <PreorderCartTrigger class-name="nav__action">Selection</PreorderCartTrigger>
        <LanguageSwitcher variant="dark" />
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import LanguageSwitcher from '~/components/LanguageSwitcher.vue'

const { getLocalizedPath } = useLocalizedRoute()

const paths = computed(() => ({
  brand: getLocalizedPath('/brand'),
  ankleBoots: getLocalizedPath('/ankle-boots')
}))
</script>

<style scoped>
.nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 30;
  pointer-events: none;
}

.nav__inner {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: start;
  padding: 1.1rem 1rem;
  color: rgba(236, 230, 220, 0.64);
}

.nav__ghost,
.nav__links,
.nav__actions {
  pointer-events: auto;
}

.nav__ghost {
  width: 7rem;
  height: 1px;
}

.nav__links {
  display: none;
  gap: 1.6rem;
  justify-self: center;
}

.nav__link,
.nav__action {
  font: inherit;
  font-size: 0.5rem;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: rgba(236, 230, 220, 0.58);
  text-decoration: none;
  background: transparent;
  border: 0;
  padding: 0;
}

.nav__action {
  cursor: pointer;
}

.nav__actions {
  display: flex;
  align-items: center;
  justify-self: end;
  gap: 0.8rem;
}

@media (min-width: 900px) {
  .nav__inner {
    padding: 1.4rem 1.8rem;
  }

  .nav__links {
    display: flex;
  }
}
</style>
